import { Spinner, cn } from "@aircall/ds";
import type { LoadingViewProps } from "./LoadingView.decl";

export function LoadingView({ className, ...props }: LoadingViewProps) {
  return (
    <div
      className={cn("mt-16 flex items-center justify-center", className)}
      {...props}
    >
      <Spinner size="xl" className="text-primary" data-test="loader" />
    </div>
  );
}
